import { createUseStyles } from "react-jss";

const styles = createUseStyles(theme => ({
  //
}));

export default styles;
